import { usePaginationControls } from '@common/hooks';
import { InitialQueryState } from '@common/types/queryState';
import { useCollections } from '@features/Collection';
import { createExtendedCollectionsPagePath } from '@router';
import { useNavigate } from 'react-router-dom';
import { CollectionAvenue } from './CollectionAvenue';

const pageSizes = [...Array(5)].map((_, i) => (i + 1) * 10);

export type ConfigMap = Record<string, InitialQueryState>;

interface ConnectedCollectionAvenueProps<TConfig extends ConfigMap> {
    configMap: TConfig;
    title: Extract<keyof TConfig, string>;
}

export const ConnectedCollectionAvenue = <TConfig extends ConfigMap>({
    configMap,
    title,
}: ConnectedCollectionAvenueProps<TConfig>) => {
    const navigate = useNavigate();
    const baseConfig = configMap[title];

    const { data, itemCount, paginationState, isLoading } = useCollections(
        {
            pageIndex: 0,
            pageSize: pageSizes[0],
            ...baseConfig,
        },
        undefined,
        { prefix: title, skipUrlSync: true },
    );

    const paginationControls = usePaginationControls({
        itemCount,
        pageSizes,
        ...paginationState,
    });

    const handleOnSeeAll = () => {
        navigate(createExtendedCollectionsPagePath(title));
    };

    return (
        <CollectionAvenue
            title={title}
            data={data}
            totalCount={itemCount}
            isLoading={isLoading}
            onSeeAll={handleOnSeeAll}
            {...paginationControls}
        />
    );
};
